const colors = require("tailwindcss/colors")
const defaultTheme = require("tailwindcss/defaultTheme")

module.exports = {
  content: [
    "./app/**/*.{js,ts,jsx,tsx}",
    "./components/**/*.{js,ts,jsx,tsx}",
    "./pages/**/*.{js,ts,jsx,tsx}",
  ],
  theme: {
    screens: {
      "sm-mobile": { min: "280px", max: "460px" },
      ...defaultTheme.screens,
    },
    colors: {
      main: colors.neutral,
      primary: colors.sky,
      secondary: colors.slate,
      tertiary: colors.lime,
      "main-light": colors.white,
      "main-dark": colors.black,
      "main-trend-up": colors.green[700],
      "main-trend-down": colors.red[700],
      ...colors,
    },
    extend: {
      fontFamily: {
        OS: "'Open Sans', sans-serif",
      },
      fontSize: {
        "3xs": "0.55rem",
        "2xs": "0.65rem",
      },
      minWidth: {
        "graf-xs": "320px",
      },
      maxWidth: {
        "graf-tray": "750px",
        "graf-md": "800px",
      },
    },
  },
  plugins: [require("@tailwindcss/forms")],
}
